export type SocialType = "facebook" | "instagram" | "default";

export const getIconType = (url:string):SocialType => {
    if(url.includes('facebook') || url.includes('fb')) return 'facebook';
    if(url.includes('instagram') || url.includes('insta')) return 'instagram';
    return 'default';
}